const subUsersValidationDE = {
    "add": {
        "first_name": {
            "required": "Vorname ist erforderlich"
        },
        "last_name": {
            "required": "Nachname ist erforderlich"
        },
        "email": {
            "required": "E-Mail ist erforderlich",
            "invalid": "E-Mail ist nicht gültig",
            "unique": "E-Mail ist mit einem anderen Benutzer verknüpft"
        },
        "username": {
            "required": "Benutzername ist erforderlich",
            "stringCaseLower": "Benutzername muss in Kleinbuchstaben sein",
            "regexp": "Benutzername darf nur aus Buchstaben und Zahlen bestehen",
            "unique": "Benutzername ist mit einem anderen Benutzer verknüpft",
            "invalid": "Benutzername ist nicht gültig"
        },
        "password": {
            "required": "Passwort ist erforderlich",
            "regexp": "Passwort muss aus mindestens 10 Zeichen bestehen, darunter 1 Großbuchstabe und 1 Sonderzeichen"
        },
        "confirmPassword": {
            "required": "Bitte Passwort bestätigen",
            "identical": "Passwort und Passwortbestätigung müssen übereinstimmen"
        },
        "contract_expiry": {
            "required": "Vertragsablaufdatum ist erforderlich"
        },
        "sub_user_deal": {
            "required": "Subuser-Deal ist erforderlich",
            "between": "Subuser-Deal muss zwischen 0 und 100 liegen"
        },
        "street_and_number": {
            "required": "Straße und Hausnummer sind erforderlich"
        },
        "postal_code": {
            "required": "Postleitzahl ist erforderlich"
        },
        "city": {
            "required": "Stadt ist erforderlich"
        },
        "country": {
            "required": "Land ist erforderlich"
        },
        "phone": {
            "required": "Telefonnummer ist erforderlich"
        }
    },
    "update": {
        "first_name": {
            "required": "Vorname ist erforderlich"
        },
        "last_name": {
            "required": "Nachname ist erforderlich"
        },
        "email": {
            "required": "E-Mail ist erforderlich",
            "invalid": "E-Mail ist nicht gültig"
        },
        "username": {
            "required": "Benutzername ist erforderlich",
            "stringCaseLower": "Benutzername muss in Kleinbuchstaben sein",
            "regexp": "Benutzername darf nur aus Buchstaben und Zahlen bestehen"
        },
        "contract_expiry": {
            "required": "Vertragsablaufdatum ist erforderlich"
        },
        "sub_user_deal": {
            "required": "Subuser-Deal ist erforderlich",
            "between": "Subuser-Deal muss zwischen 0 und 100 liegen"
        },
        "street_and_number": {
            "required": "Straße und Hausnummer sind erforderlich"
        },
        "postal_code": {
            "required": "Postleitzahl ist erforderlich"
        },
        "city": {
            "required": "Stadt ist erforderlich"
        },
        "country": {
            "required": "Land ist erforderlich"
        },
        "phone": {
            "required": "Telefonnummer ist erforderlich"
        }
    }
};

export default subUsersValidationDE;